<script>
    export default {
        name: "FormStatusMixin",
        data() {
            return {
                formStatus: 'initial',
            }
        },
        methods: {
            getFormStatus () {
                return this.formStatus;
            },
            setFormStatus (status) {
                this.formStatus = status;
                this.setChangesAreSaved(false);
            },
        },
        watch: {
            formStatus () {
                if (this.formStatus === 'submitted') {
                    this.elementNode.classList.add('form-submitted');
                } else {
                    this.elementNode.classList.remove('form-submitted');
                }
            }
        }
    }
</script>